export default {
  departments: []
}
